module.exports = __webpack_public_path__ + "static/media/Studentssample.10a03d8e.xls";